(() => {
  if (customElements.get('pp-search-marker')) return;
  customElements.define('pp-search-marker', class extends HTMLElement {});
  function init(root = document) {
    root.querySelectorAll('[data-pp-blog-search]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const form = box.querySelector('form'), input = form.elements.q;
      const result = box.querySelector('[data-pp-results]');
      const status = box.querySelector('[role="status"]');
      const reset = box.querySelector('.pp-search-reset');
      let controller, sequence = 0;
      function clear() {
        sequence++; controller?.abort();
        result.hidden = true; result.replaceChildren(); reset.hidden = true;
        status.textContent = ''; box.removeAttribute('aria-busy');
      }
      async function show(url) {
        controller?.abort(); controller = new AbortController();
        const ticket = ++sequence;
        const activeController = controller;
        status.textContent = 'Søger …'; box.setAttribute('aria-busy', 'true');
        result.hidden = true; reset.hidden = false;
        const timeout = setTimeout(() => activeController.abort(), 15000);
        try {
          const response = await fetch(url, {signal: activeController.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Search unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-pp-search-page-results]');
          if (!content) throw new Error('Search template missing');
          if (ticket !== sequence) return;
          result.replaceChildren(document.importNode(content, true)); result.hidden = false;
          status.textContent = '';
          result.querySelector('[data-pp-result-heading]')?.focus({preventScroll: true});
          result.scrollIntoView({behavior: 'auto', block: 'nearest'});
        } catch (error) {
          if (ticket !== sequence) return;
          status.replaceChildren(document.createTextNode('Søgningen kunne ikke vises her. '));
          const link = document.createElement('a'); link.href = url; link.textContent = 'Åbn søgeresultaterne'; status.append(link);
        } finally {
          clearTimeout(timeout);
          if (ticket === sequence) box.removeAttribute('aria-busy');
        }
      }
      form.addEventListener('submit', event => {
        if (!input.value.trim()) {event.preventDefault(); input.focus(); return;}
        event.preventDefault();
        const url = new URL(form.action, location.href);
        url.search = new URLSearchParams(new FormData(form)).toString();
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        show(url.href);
      });
      result.addEventListener('click', event => {
        const link = event.target.closest('.pp-editorial-pagination a');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); show(link.href);
      });
      reset.addEventListener('click', () => {clear(); input.value = ''; input.focus();});
      input.addEventListener('input', () => {clear();});
      input.addEventListener('keydown', event => {if (event.key === 'Escape') {clear(); input.focus();}});
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
